import React from "react";

// Import Authentication pages
import Login from "../Pages/Authentication/Login";
import ForgetPasswordPage from "../Pages/Authentication/ForgetPassword";
import Logout from "../Pages/Authentication/Logout";

// Import Utility Pages
import StarterPage from "../Pages/Utility/Starter-Page";
import Maintenance from "../Pages/Utility/Maintenance-Page";
import ComingSoon from "../Pages/Utility/ComingSoon-Page";
import TimeLine from "../Pages/Utility/TimeLine-Page";
import FAQs from "../Pages/Utility/FAQs-Page";
import Pricing from "../Pages/Utility/Pricing-Page";
import Error404 from "../Pages/Utility/Error404-Page";
import Error500 from "../Pages/Utility/Error500-Page";

// Import UIElement Pages
import UiAlerts from "../Pages/Ui/UiElements/UiAlerts";
import UiBadge from "../Pages/Ui/UiElements/UiBadge";
import UiBreadcrumb from "../Pages/Ui/UiElements/UiBreadcrumb";
import UiButtons from "../Pages/Ui/UiElements/UiButtons";
import UiCards from "../Pages/Ui/UiElements/UiCards";
import UiCarousel from "../Pages/Ui/UiElements/UiCarousel";
import UiDropdown from "../Pages/Ui/UiElements/UiDropdowns";
import UiGrid from "../Pages/Ui/UiElements/UiGrid";
import UiImages from "../Pages/Ui/UiElements/UiImages";
import UiLightbox from "../Pages/Ui/UiElements/UiLightbox";
import UiModals from "../Pages/Ui/UiElements/UiModals";
import UiOffcanvas from "../Pages/Ui/UiElements/UiOffcanvas";
import UiRangeSlider from "../Pages/Ui/UiElements/UiRangeSlider";
import UiSessionTimeout from "../Pages/Ui/UiElements/UiSessionTimeout";
import UiPagination from "../Pages/Ui/UiElements/UiPagination";
import UiProgressBars from "../Pages/Ui/UiElements/UiProgressBars";
import UiPlaceholders from "../Pages/Ui/UiElements/UiPlaceholders";
import UiTabs from "../Pages/Ui/UiElements/UiTabs&Accordions";
import UiTypography from "../Pages/Ui/UiElements/UiTypography";
import UiToasts from "../Pages/Ui/UiElements/UiToasts";
import UiVideo from "../Pages/Ui/UiElements/UiVideo";
import UiPopovers from "../Pages/Ui/UiElements/UiPopovers&Tooltips";
import UiRating from "../Pages/Ui/UiElements/UiRating";

// Import Ui/Forms
import FormCustom from "../Pages/Ui/Forms/FormCustom.js";
import FormEditors from "../Pages/Ui/Forms/FormEditors";
import FormUpload from "../Pages/Ui/Forms/FormUpload";
import FormMask from "../Pages/Ui/Forms/FormMask";
import FormElements from "../Pages/Ui/Forms/FormElements";
import FormAdvanced from "../Pages/Ui/Forms/FormAdvanced";
import FormValidations from "../Pages/Ui/Forms/FormValidations";
import FormWizard from "../Pages/Ui/Forms/FormWizard";
import FormCalendar from "../Pages/Ui/Forms/FormCalendar.js";

// Import Tables
import BasicTable from "../Pages/Ui/Tables/BasicTable.js";
import ListJs from "../Pages/Ui/Tables/ListTables/ListTables";
import DataTable from "../Pages/Ui/Tables/DataTables/DataTables";

// Import Charts
import ChartJs from "../Pages/Ui/Charts/ChartjsCharts";
import Sparklinechart from "../Pages/Ui/Charts/SparklineCharts";
import FloatChart from "../Pages/Ui/Charts/FloatCharts";
import JknobCharts from "../Pages/Ui/Charts/JqueryKnobCharts";

// Import Icon Pages
import IconMaterialdesign from "../Pages/Ui/Icons/IconMaterialdesign";
import IconFontawesome from "../Pages/Ui/Icons/IconFontAwesome";
import IconDripicons from "../Pages/Ui/Icons/IconDrip";
import IconBoxicons from "../Pages/Ui/Icons/IconBoxicons";

import Ui from "../Pages/Ui";
import ErrorPermissionDenied from "../Pages/Utility/ErrorPermissionDenied.js";

import LegalContentPage from "../Pages/LegalContentPage/index.js";

import { LOGIN } from "../helpers/routes_helper.js";
import { Navigate } from "react-router-dom";
import config from "../config.js";
import JSONToolsView from "../Pages/Ui/Tools/JSONToolsView.js";
import ExportTemplatePreviewView from "../Pages/Ui/Tools/ExportTemplatePreviewView.js";

// Workspace
import BI_WS0025 from "../Pages/BI_WS0025/index.js";

// MyOrder
import DF_MO0004 from "../Pages/DF_MO0004/index.js";
import DF_MO0007 from "../Pages/DF_MO0004/DF_MO0007/index.js";
import DF_MO0006 from "../Pages/DF_MO0004/DF_MO0006/index.js";
import DF_MO0010 from "../Pages/DF_MO0004/DF_MO0010/index.js";

//Comply
import DF_CO0004 from "../Pages/DF_CO0002/DF_CO0004/index.js";
import DF_CO0005 from "../Pages/DF_CO0002/DF_CO0005/index.js";
import DF_CO0008 from "../Pages/DF_CO0002/DF_CO0008/index.js";
import DF_CO0009 from "../Pages/DF_CO0002/DF_CO0009/index.js";
import DF_CO0010 from "../Pages/DF_CO0002/DF_CO0010/index.js";
import DF_CO0002 from "../Pages/DF_CO0002/index.js";
import DF_CO0003 from "../Pages/DF_CO0002/DF_CO0003/index.js";

//Logi+
import DF_LO0003 from "../Pages/DF_LO0003/index.js";
import DF_LO0008 from "../Pages/DF_LO0008/index.js";
import DF_LO0009 from "../Pages/DF_LO0009/index.js";
import DF_LO0011 from "../Pages/DF_LO0011/index.js";
import DF_LO0012 from "../Pages/DF_LO0012/index.js";

// Agendamento
import DF_OT0011 from "../Pages/DF_OT0011/index.js";
import DF_OT0011A from "../Pages/DF_OT0011/DF_OT0011A/index.js";
import DF_OT0012 from "../Pages/DF_OT0012/index.js";
import DF_OT0014 from "../Pages/DF_OT0012/DF_OT0014/index.js";
import DF_OT0015 from "../Pages/DF_OT0015/index.js";
import DF_OT0016 from "../Pages/DF_OT0016/index.js";
import DF_OT0018 from "../Pages/DF_OT0016/DF_OT0018/index.js";
import DF_OT0019 from "../Pages/DF_OT0016/DF_OT0019/index.js";
import DF_OT0022 from "../Pages/DF_OT0022/index.js";
import DF_OT0023 from "../Pages/DF_OT0022/DF_OT0023/index.js";
import DF_OT0024 from "../Pages/DF_OT0022/DF_OT0024/index.js";
import DF_OT0030 from "../Pages/DF_OT0030/index.js";
import DF_OT0050 from "../Pages/DF_OT0050/index.js";
import DF_OT0051 from "../Pages/DF_OT0050/DF_OT0051/index.js";
import DF_OT0052 from "../Pages/DF_OT0050/DF_OT0052/index.js";
import DF_OT0053 from "../Pages/DF_OT0050/DF_OT0053/index.js";
import DF_OT0055 from "../Pages/DF_OT0055/index.js";
import DF_OT0056 from "../Pages/DF_OT0055/DF_OT0056/index.js";
import DF_OT0058 from "../Pages/DF_OT0055/DF_OT0058/index.js";
import DF_OT0059 from "../Pages/DF_OT0055/DF_OT0059/index.js";
import DF_OT0086 from "../Pages/DF_OT0086/index.js";

// Gestão de Fretes
import DF_LO0020 from "../Pages/DF_LO0020/index.js";
import DF_LO0021 from "../Pages/DF_LO0020/DF_LO0021/index.js";
import DF_LO0022 from "../Pages/DF_LO0020/DF_LO0022/index.js";
import DF_LO0023 from "../Pages/DF_LO0020/DF_LO0023/index.js";
import DF_LO0024 from "../Pages/DF_LO0020/DF_LO0024/index.js";
import DF_LO0025 from "../Pages/DF_LO0020/DF_LO0025/index.js";

//Gestão de Entregas
import DF_OT0040 from "../Pages/DF_OT0040/index.js";
import DF_OT0070 from "../Pages/DF_OT0070/index.js";

const authProtectedRoutes = [
  // Utility Pages
  { path: "/pages-starter", component: <StarterPage /> },
  { path: "/pages-timeline", component: <TimeLine /> },
  { path: "/pages-faqs", component: <FAQs /> },
  { path: "/pages-pricing", component: <Pricing /> },

  ...(config.NODE_ENV === "development"
    ? [
        // Ui Labolatory
        { path: "/ui", component: <Ui /> },

        // Ui/UiElements Pages
        { path: "/ui-alerts", component: <UiAlerts /> },
        { path: "/ui-badge", component: <UiBadge /> },
        { path: "/ui-breadcrumb", component: <UiBreadcrumb /> },
        { path: "/ui-buttons", component: <UiButtons /> },
        { path: "/ui-cards", component: <UiCards /> },
        { path: "/ui-carousel", component: <UiCarousel /> },
        { path: "/ui-dropdowns", component: <UiDropdown /> },
        { path: "/ui-grid", component: <UiGrid /> },
        { path: "/ui-images", component: <UiImages /> },
        { path: "/ui-lightbox", component: <UiLightbox /> },
        { path: "/ui-modals", component: <UiModals /> },
        { path: "/ui-offcanvas", component: <UiOffcanvas /> },
        { path: "/ui-rangeslider", component: <UiRangeSlider /> },
        { path: "/ui-sessiontimeout", component: <UiSessionTimeout /> },
        { path: "/ui-pagination", component: <UiPagination /> },
        { path: "/ui-progressbars", component: <UiProgressBars /> },
        { path: "/ui-placeholders", component: <UiPlaceholders /> },
        { path: "/ui-tabs-accordions", component: <UiTabs /> },
        { path: "/ui-typography", component: <UiTypography /> },
        { path: "/ui-toasts", component: <UiToasts /> },
        { path: "/ui-video", component: <UiVideo /> },
        { path: "/ui-popovers", component: <UiPopovers /> },
        { path: "/ui-rating", component: <UiRating /> },

        // Ui/Forms pages
        { path: "/form-elements", component: <FormElements /> },
        { path: "/form-validation", component: <FormValidations /> },
        { path: "/form-advanced", component: <FormAdvanced /> },
        { path: "/form-editor", component: <FormEditors /> },
        { path: "/form-custom", component: <FormCustom /> },
        { path: "/form-uploads", component: <FormUpload /> },
        { path: "/form-wizard", component: <FormWizard /> },
        { path: "/form-mask", component: <FormMask /> },
        { path: "/form-calendar", component: <FormCalendar /> },

        // Ui/Tables pages
        { path: "/tables-basic", component: <BasicTable /> },
        { path: "/tables-listjs", component: <ListJs /> },
        { path: "/table-datatables", component: <DataTable /> },

        // Ui/Charts Pages
        { path: "/chart-chartjscharts", component: <ChartJs /> },
        { path: "/chart-floatcharts", component: <FloatChart /> },
        { path: "/chart-jknobcharts", component: <JknobCharts /> },
        { path: "/chart-sparklinecharts", component: <Sparklinechart /> },

        // Ui/Icons Pages
        { path: "/icon-boxicon", component: <IconBoxicons /> },
        { path: "/icons-materialdesign", component: <IconMaterialdesign /> },
        { path: "/icons-fontawesome", component: <IconFontawesome /> },
        { path: "/icon-dripicons", component: <IconDripicons /> },

        // Ui/JSON Tools Pages
        { path: "/json-tools", component: <JSONToolsView /> },

        // Ui/Export Template Preview
        { path: "/export-template-preview", component: <ExportTemplatePreviewView /> },
      ]
    : []),

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  // {
  //   path: "/",
  //   exact: true,
  //   component: <Navigate to="/dashboard" />,
  // },

  { path: "/permissao-negada", component: <ErrorPermissionDenied /> },
  { path: "/404", component: <Error404 /> },
  { path: "*", component: <Error404 /> },

  // My Order
  { path: "/DF_MO0004", component: <DF_MO0004 /> },
  { path: "/DF_MO0007", component: <DF_MO0007 /> },
  { path: "/DF_MO0006", component: <DF_MO0006 /> },
  { path: "/DF_MO0010", component: <DF_MO0010 /> },

  // Comply
  { path: "/DF_CO0005", component: <DF_CO0005 /> },
  { path: "/DF_CO0008", component: <DF_CO0008 /> },
  { path: "/DF_CO0009", component: <DF_CO0009 /> },
  { path: "/DF_CO0010", component: <DF_CO0010 /> },
  { path: "/DF_CO0002", component: <DF_CO0002 /> },
  { path: "/DF_CO0004", component: <DF_CO0004 /> },
  { path: "/DF_CO0003", component: <DF_CO0003 /> },

  // Logi+
  { path: "/DF_LO0003", component: <DF_LO0003 /> },
  { path: "/DF_LO0008", component: <DF_LO0008 /> },
  { path: "/DF_LO0009", component: <DF_LO0009 /> },
  { path: "/DF_LO0011", component: <DF_LO0011 /> },
  { path: "/DF_LO0012", component: <DF_LO0012 /> },

  // On Time
  { path: "/DF_OT0030", component: <DF_OT0030 /> },
  { path: "/DF_OT0022", component: <DF_OT0022 /> },
  { path: "/DF_OT0023", component: <DF_OT0023 /> },
  { path: "/DF_OT0024", component: <DF_OT0024 /> },
  { path: "/DF_OT0050", component: <DF_OT0050 /> },
  { path: "/DF_OT0051", component: <DF_OT0051 /> },
  { path: "/DF_OT0052", component: <DF_OT0052 /> },
  { path: "/DF_OT0053", component: <DF_OT0053 /> },
  { path: "/DF_OT0012", component: <DF_OT0012 /> },
  { path: "/DF_OT0014", component: <DF_OT0014 /> },
  { path: "/DF_OT0015", component: <DF_OT0015 /> },
  { path: "/DF_OT0016", component: <DF_OT0016 /> },
  { path: "/DF_OT0018", component: <DF_OT0018 /> },
  { path: "/DF_OT0019", component: <DF_OT0019 /> },
  { path: "/BI_WS0025", component: <BI_WS0025 /> },
  { path: "/DF_OT0011", component: <DF_OT0011 /> },
  { path: "/DF_OT0011A", component: <DF_OT0011A /> },
  { path: "/DF_OT0055", component: <DF_OT0055 /> },
  { path: "/DF_OT0056", component: <DF_OT0056 /> },

  { path: "/DF_OT0058", component: <DF_OT0058 /> },
  { path: "/DF_OT0059", component: <DF_OT0059 /> },
  { path: "/DF_OT0086", component: <DF_OT0086 /> },

  // Logi+ - Gestão de Fretes
  { path: "/DF_LO0020", component: <DF_LO0020 /> },
  { path: "/DF_LO0021", component: <DF_LO0021 /> },
  { path: "/DF_LO0022", component: <DF_LO0022 /> },
  { path: "/DF_LO0023", component: <DF_LO0023 /> },
  { path: "/DF_LO0024", component: <DF_LO0024 /> },
  { path: "/DF_LO0025", component: <DF_LO0025 /> },

  // Gestão de Entregas
  { path: "/DF_OT0040", component: <DF_OT0040 /> },

  // Consulta Agenda Fixa
  { path: "/DF_OT0070", component: <DF_OT0070 /> },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: LOGIN, component: <Login /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/BI_AC0002", component: <ForgetPasswordPage /> },
  //{ path: '/termos-de-uso', component: <BI_EX0003 /> },
  //{ path: '/BI_EX0003', component: <BI_EX0003 /> },
  { path: "/BI_EX0003", component: <LegalContentPage /> },
  { path: "/BI_EX0004", component: <LegalContentPage /> },

  // Utility Pages
  { path: "/pages-500", component: <Error500 /> },
  { path: "/pages-maintenance", component: <Maintenance /> },
  { path: "/pages-comingsoon", component: <ComingSoon /> },
];

export { authProtectedRoutes, publicRoutes };
